// Styles
import './hover-select-option.scss';

const HoverSelectOption = ({ label, description, onClick }) => (
  <button
    type="button"
    className="hover-select-option"
    onClick={onClick}
  >
    <span className="hover-select-option__content">
      <span className="hover-select-option__label">{label}</span>
      {description && (
        <span className="hover-select-option__description">{description}</span>
      )}
    </span>
  </button>
);

export default HoverSelectOption;
